<!-- 针对不同模块的失败原因，做不同的处理 -->
<template>
  <div>
    <!-- 更新为根据failureDescription前缀 -->
    <div v-if="isHttp">
      <!-- 只有处理失败\部分成功才显示 按钮 -->
      <el-link v-if="['2','4'].includes(row.type)" :href="row.failureDescription" target="_blank">{{ $t('GlobalSetObj.clickDown') }}</el-link>
    </div>

    <!-- 其它模块 -->
    <span v-else>{{ row.failureDescription }}</span>
  </div>
</template>

<script>
import { MODULE_OBJ, IMPORT_STATUS_OBJ } from './../utils';

export default {
  name: '',

  props: {
    row: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      MODULE_OBJ,
      IMPORT_STATUS_OBJ
    };
  },

  computed: {
    isHttp() {
      const str = this.row.failureDescription;
      try {
        const url = new URL(str);
        return url.protocol === 'https:';
      } catch {
        return false;
      }
    }
  }
};
</script>

